import { getTaskNotes, addTaskNotes, updateTaskNotes, deleteTaskNotes, sortTaskNote, getTaskNewNotes, emptyTaskNotes } from '@/api/notes'

const notes = {
  state: {
    total: 0,
    rows: [],
    row: {},
    status: 0,
    appealStatus: 0,
    appealUnStatus: 0,
    agencyStatus: 0,
    agencyUnStatus: 0,
    purchaseStatus: 0,
    saleStatus: 0,
    fileStatus: 0,
    reimbursementStatus: 0,
    cashRequirementStatus: 0
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    },
    SET_NOTE_STATUS: (state, status) => {
      state.status = status
    },
    SET_FILE_STATUS: (state, status) => {
      state.fileStatus = status
    },
    SET_APPEAL_STATUS: (state, appealStatus) => {
      state.appealStatus = appealStatus
    },
    SET_AGENCY_STATUS: (state, agencyStatus) => {
      state.agencyStatus = agencyStatus
    },
    SET_UN_APPEAL_STATUS: (state, appealUnStatus) => {
      state.appealUnStatus = appealUnStatus
    },
    SET_UN_AGENCY_STATUS: (state, agencyUnStatus) => {
      state.agencyUnStatus = agencyUnStatus
    },
    SET_PURCHASE_STATUS: (state, purchaseStatus) => {
      state.purchaseStatus = purchaseStatus
    },
    SET_SALE_STATUS: (state, saleStatus) => {
      state.saleStatus = saleStatus
    },
    SET_REIMBURSEMENT_STATUS: (state, reimbursementStatus) => {
      state.reimbursementStatus = reimbursementStatus
    },
    SET_CASE_REQUIREMENT_STATUS: (state, cashRequirementStatus) => {
      state.cashRequirementStatus = cashRequirementStatus
    }
  },
  actions: {
    // 查询笔记
    GetTaskNotes({ commit }, params) {
      return new Promise((resolve, reject) => {
        getTaskNotes(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加笔记
    AddTaskNotes({ commit }, params) {
      return new Promise((resolve, reject) => {
        addTaskNotes(params).then((response) => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改笔记
    UpdateTaskNotes({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateTaskNotes(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除笔记
    DeleteTaskNotes({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteTaskNotes(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 排序
    SortTaskNote({ commit }, params) {
      return new Promise((resolve, reject) => {
        sortTaskNote(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 新任务
    GetTaskNewNotes({ commit }, params) {
      return new Promise((resolve, reject) => {
        getTaskNewNotes(params).then(response => {
          commit('SET_NOTE_STATUS', response.Data.Total)
          commit('SET_FILE_STATUS', response.Data.NewFileStatus)
          commit('SET_APPEAL_STATUS', response.Data.NewAppealStatus)
          commit('SET_UN_APPEAL_STATUS', response.Data.NewUnAppealStatus)
          commit('SET_AGENCY_STATUS', response.Data.NewAgencyStatus)
          commit('SET_UN_AGENCY_STATUS', response.Data.NewUnAgencyStatus)
          commit('SET_PURCHASE_STATUS', response.Data.NewPurchaseStatus)
          commit('SET_SALE_STATUS', response.Data.NewSaleStatus)
          commit('SET_REIMBURSEMENT_STATUS', response.Data.NewReimbursementStatus)
          commit('SET_CASE_REQUIREMENT_STATUS', response.Data.NewCashRequirementStatus)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 清空笔记状态
    EmptyTaskNotes({ commit }, params) {
      return new Promise((resolve, reject) => {
        emptyTaskNotes(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default notes



// WEBPACK FOOTER //
// ./src/store/modules/notes.js